"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BirthdayModule = void 0;
var date_helper_const_1 = require("@src/const/date-helper.const");
var error_helper_const_1 = require("@src/const/error-handling/error-helper.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var input_output_module_const_1 = require("@src/const/input-output-module.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var module_handler_service_1 = require("@src/services/module-handler.service");
var object_service_1 = require("@src/services/object-service");
var translation_1 = __importDefault(require("@src/services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var BirthdayModule = /** @class */ (function () {
    function BirthdayModule() {
        this.childModuleInstances = [];
        this.settings = {
            includeLastYears: 120,
            shortMonths: true,
            minimumAge: 18, // Customers below this age are not allowed
            matureAge: 18, // Customers between minimumAge and matureAge require guardian approval
            underAgeContracts: false,
            showErrors: false,
            allowUnmatured: false,
        };
        this.guardianValid = false;
        this.interCom = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
    }
    BirthdayModule.prototype.loadModule = function (dataAttributes) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, dropdowns, prefilled, preselectedDateOfBirth, _b, y, m, d, _i, dropdowns_1, dropdown, v, errorFieldRef;
            var _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(this.settings.underAgeContracts && this.settings.minimumAge < this.settings.matureAge)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, (0, module_handler_service_1._BootstrapModuleIfNoChildModule)(this.$container, 'guardian', { showErrors: false })];
                    case 1:
                        _a.guardianModule = (_d.sent()).instance;
                        this.guardianModule.$container.css('display', 'none');
                        _d.label = 2;
                    case 2:
                        this.interCom.subscribeChildren(this).subscribe(function (event) {
                            var _a;
                            if (event.event === 'validation' && ((_a = event.module) === null || _a === void 0 ? void 0 : _a.moduleKey) === 'guardian') {
                                _this.guardianValid = event.value.valid;
                                _this.guardian = event.value.valid ? event.value.data : undefined;
                            }
                        });
                        dropdowns = [input_mapping_const_1._BirthdayForm.yearOfBirth, input_mapping_const_1._BirthdayForm.monthOfBirth, input_mapping_const_1._BirthdayForm.dayOfBirth].map(function (a) {
                            var _a, _b, _c;
                            var dropdownElement = (_c = (_b = (_a = dataAttributes === null || dataAttributes === void 0 ? void 0 : dataAttributes.valueHandlers) === null || _a === void 0 ? void 0 : _a[a.uid]) === null || _b === void 0 ? void 0 : _b.elements) === null || _c === void 0 ? void 0 : _c[0];
                            if (!dropdownElement) {
                                dropdownElement = (0, input_output_helper_const_1._GenerateField)(_this.$container, a).find('select');
                            }
                            return { ele: dropdownElement, field: a };
                        });
                        prefilled = false;
                        preselectedDateOfBirth = (0, input_output_helper_const_1._ShouldPrefillFromLocalStorage)() ? localStorage.getItem(input_mapping_const_1._BirthdayForm.dateOfBirth.uid) : null;
                        _b = [null, null, null], y = _b[0], m = _b[1], d = _b[2];
                        if (preselectedDateOfBirth) {
                            _c = preselectedDateOfBirth.split('-'), y = _c[0], m = _c[1], d = _c[2];
                            // drop leading zeroes if your <option> values are un-padded:
                            m = String(parseInt(m, 10));
                            d = String(parseInt(d, 10));
                        }
                        for (_i = 0, dropdowns_1 = dropdowns; _i < dropdowns_1.length; _i++) {
                            dropdown = dropdowns_1[_i];
                            if (dropdown.field.uid === 'customer.yearOfBirth') {
                                this.extendYears(dropdown.ele);
                            }
                            if (dropdown.field.uid === 'customer.monthOfBirth') {
                                this.extendMonths(dropdown.ele);
                            }
                            if (dropdown.field.uid === 'customer.dayOfBirth') {
                                this.extendDays(dropdown.ele);
                            }
                            v = null;
                            if (dropdown.field.uid === 'customer.yearOfBirth')
                                v = y;
                            if (dropdown.field.uid === 'customer.monthOfBirth')
                                v = m;
                            if (dropdown.field.uid === 'customer.dayOfBirth')
                                v = d;
                            if (v != null) {
                                dropdown.ele.val(v);
                                prefilled = true;
                            }
                        }
                        if (prefilled)
                            this.validateModule(); // if prefilled, fire the validation event already
                        dropdowns.forEach(function (a) {
                            a.ele.on('change', function () {
                                _this.validateModule();
                            });
                        });
                        errorFieldRef = this.module.references.errorField.domElement;
                        if (errorFieldRef === null || errorFieldRef === void 0 ? void 0 : errorFieldRef.length) {
                            errorFieldRef.html(translation_1.default.t('You have to be at least') + ' ' + this.settings.minimumAge + ' ' + translation_1.default.t('years old'));
                            errorFieldRef.hide();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BirthdayModule.prototype.validateModule = function () {
        var _a, _b, _c;
        this.determineBirthDate();
        (_a = this.domErrorMessage) === null || _a === void 0 ? void 0 : _a.remove();
        var errorText = '';
        var errorFieldRef = this.module.references.errorField.domElement;
        if (!(errorFieldRef === null || errorFieldRef === void 0 ? void 0 : errorFieldRef.length)) {
            errorFieldRef = (0, cash_dom_1.default)('<div>').attr('data-ref', 'birthday-error-message').css('color', 'red').css('width', '100%');
            this.$container.append(errorFieldRef);
            this.module.references.errorField.domElement = errorFieldRef; // otherwise we keep creating them
        }
        errorFieldRef.hide();
        // Update guardian module visibility immediately:
        if (this.guardianModule) {
            if (!((_b = this.birthday) === null || _b === void 0 ? void 0 : _b.length) || this.age < this.settings.minimumAge || this.age >= this.settings.matureAge) {
                this.guardianModule.$container.css('display', 'none');
            }
            else if (this.age >= this.settings.minimumAge && this.age < this.settings.matureAge && this.settings.underAgeContracts) {
                this.guardianModule.$container.css('display', 'block');
            }
        }
        if (!((_c = this.birthday) === null || _c === void 0 ? void 0 : _c.length)) {
            errorText = translation_1.default.t('Please provide the birthday');
        }
        else if (this.age < this.settings.minimumAge) {
            errorText = translation_1.default.t('Not old enough');
        }
        else if (this.age < this.settings.matureAge) {
            if (this.settings.underAgeContracts) {
                if (this.settings.showErrors) {
                    this.guardianModule.settings.showErrors = true;
                    this.guardianModule.validateModule();
                }
                return this.sendEvent({
                    valid: this.guardianValid,
                    data: {
                        age: this.age,
                        birthday: this.birthday,
                        birthdayts: this.birthdayts,
                        guardian: this.guardianValid ? this.guardian : undefined,
                    },
                });
            }
            else {
                console.log('under mature age, above minium and no guardian module');
                if (this.settings.allowUnmatured && this.age >= this.settings.minimumAge) {
                    return this.sendEvent({
                        valid: true,
                        data: { age: this.age, birthday: this.birthday, birthdayts: this.birthdayts },
                    });
                }
                errorText = translation_1.default.t('Not old enough');
            }
        }
        else if (this.age >= this.settings.matureAge) {
            return this.sendEvent({
                valid: true,
                data: { age: this.age, birthday: this.birthday, birthdayts: this.birthdayts },
            });
        }
        if (errorText.length && this.settings.showErrors) {
            this.domErrorMessage = (0, error_helper_const_1._AddErrorToDomObject)(errorFieldRef, errorText);
        }
        // show the "You have to be at least X years old" message
        if (errorFieldRef.length && this.age < this.settings.matureAge) {
            errorFieldRef.show();
        }
        var result = { valid: false, errorMessage: errorText };
        this.lastValidationResult = result;
        this.sendEvent(result);
        console.log('Birthday validation result', result);
        return result;
    };
    BirthdayModule.prototype.validateAll = function (showErrors) {
        if (showErrors === void 0) { showErrors = false; }
        this.settings.showErrors = showErrors;
        if (this.guardianModule) {
            this.guardianModule.settings.showErrors = showErrors;
        }
        return this.validateModule();
    };
    BirthdayModule.prototype.sendEvent = function (value) {
        this.interCom.sendEvent({
            module: this,
            event: 'validation',
            value: value,
        });
        return value;
    };
    BirthdayModule.prototype.determineBirthDate = function () {
        (0, input_output_module_const_1.ValidateFieldsInModule)(this, {
            showErrors: this.settings.showErrors,
            mappings: input_mapping_const_1._BirthdayForm,
            animateToFirstError: false,
        });
        var _a = [
            (0, input_output_module_const_1._ReadFieldInModule)(input_mapping_const_1._BirthdayForm.yearOfBirth, this),
            (0, input_output_module_const_1._ReadFieldInModule)(input_mapping_const_1._BirthdayForm.monthOfBirth, this),
            (0, input_output_module_const_1._ReadFieldInModule)(input_mapping_const_1._BirthdayForm.dayOfBirth, this),
        ], year = _a[0], month = _a[1], day = _a[2];
        if (+year && +month && +day) {
            var selectedBirthDate = (0, date_helper_const_1._ProperISODate)(year, month, day);
            var userAge = (0, date_helper_const_1._GetAgeFromBirthday)(selectedBirthDate);
            this.age = userAge;
            this.birthday = selectedBirthDate;
            this.birthdayts = Date.parse(selectedBirthDate);
        }
        else {
            delete this.age;
            delete this.birthday;
            delete this.birthdayts;
        }
    };
    BirthdayModule.prototype.extendYears = function (dropdown) {
        dropdown.children('option').remove();
        dropdown.append((0, cash_dom_1.default)('<option>').text(translation_1.default.t('YEAR')));
        for (var year = new Date().getFullYear() - this.settings.minimumAge; year >= new Date().getFullYear() - this.settings.includeLastYears; year--) {
            dropdown.append((0, cash_dom_1.default)('<option>').val(String(year)).text(String(year)));
        }
    };
    BirthdayModule.prototype.extendMonths = function (dropdown) {
        dropdown.children('option').remove();
        dropdown.append((0, cash_dom_1.default)('<option>').text(translation_1.default.t('MONTH')));
        for (var month = 0; month < 12; month++) {
            var option = (0, cash_dom_1.default)('<option></option>')
                .val(String(month + 1))
                .text(translation_1.default.t(date_helper_const_1._Months[month][this.settings.shortMonths ? 'short' : 'name']));
            dropdown.append(option);
        }
    };
    BirthdayModule.prototype.extendDays = function (dropdown) {
        dropdown.children('option').remove();
        dropdown.append((0, cash_dom_1.default)('<option>').text(translation_1.default.t('DAY')));
        for (var day = 0; day < 31; day++) {
            var option = (0, cash_dom_1.default)('<option></option>')
                .val(String(day + 1))
                .text(String(day + 1));
            dropdown.append(option);
        }
    };
    return BirthdayModule;
}());
exports.BirthdayModule = BirthdayModule;
